export const iconsImages = {
  image1: require("../Asset/icons/2.png"),
  image2: require("../Asset/icons/3.png"),
  image3: require("../Asset/icons/4.png"),
};

export const Gallary = [
  require("../Asset/Gallary/image5.jpg"),
  require("../Asset/Gallary/image6.jpg"),
  require("../Asset/Gallary/image7.jpg"),
  require("../Asset/Gallary/image8.jpg"),
];
